import { render, staticRenderFns } from "./configAnimals.vue?vue&type=template&id=381322a4&"
import script from "./configAnimals.vue?vue&type=script&lang=js&"
export * from "./configAnimals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports